import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  statusContainer: {
    display: 'flex',
    width: 'fit-content',
    background: 'pink',
    padding: '4px 8px',
    borderRadius: 8
  },
  greenStatus: { background: theme.palette.secondary.main },
  blueStatus: { background: theme.palette.info.main },
  greyStatus: { background: theme.palette.grey[300] },
  redStatus: { background: theme.palette.primary.main },
  statusText: { color: theme.palette.primary.contrastText, fontSize: 13 }
}))
